import { useEffect, useState } from 'react';

import { isTestModeOn, setTestModeOn, TEST_MODE_EVENT } from '../utils/testMode';

/**
 * The Test Mode switch as React state. Every mounted consumer re-renders
 * together via the window event — the banner, the menu tint, and the
 * activity lists flip as one.
 */
export default function useTestMode(clientId) {
  const [on, setOn] = useState(() => !!clientId && isTestModeOn(clientId));

  useEffect(() => {
    if (!clientId) return undefined;
    setOn(isTestModeOn(clientId));
    const handler = (e) => {
      if (!e.detail) return;
      if (e.detail.clientId === clientId) setOn(!!e.detail.on);
      else if (e.detail.global) setOn(isTestModeOn(clientId));
    };
    window.addEventListener(TEST_MODE_EVENT, handler);
    return () => window.removeEventListener(TEST_MODE_EVENT, handler);
  }, [clientId]);

  // The lens is UNGATED: if a mode is set for this client in this browser,
  // it is the truth and every surface (chrome + lists) reflects it. Gating
  // lives on the switch AFFORDANCE instead — partners flip their own
  // (isDeveloper), Strike Admins flip anyone's (admin developer screen).
  const setMode = (next) => setTestModeOn(clientId, next);
  return [!!clientId && on, setMode];
}
